// Модальное окно  добавления измерений усилий натяжения в канатах оттяжек мачты

// AddTensionsMeasurements.jsx
import React, { useState } from 'react';
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CForm,
  CRow,
  CCol,
  CFormLabel,
  CFormInput,
  CTable,
  CTableHead,
  CTableBody,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell
} from '@coreui/react';
import AddTensionsMeasurementsMarks from './AddTensionsMeasurementsMarks';

const AddTensionsMeasurements = ({ visible, onClose, onSave }) => {
  const [floorNumber, setFloorNumber] = useState('');
  const [nodeElevation, setNodeElevation] = useState('');
  const [projectRopeDiameter, setProjectRopeDiameter] = useState('');
  const [tableData, setTableData] = useState([]);
  const [isMarksModalVisible, setIsMarksModalVisible] = useState(false);

  const handleSave = () => {
    const measurementData = {
      floorNumber,
      nodeElevation,
      projectRopeDiameter,
      tableData
    };
    onSave(measurementData);
    resetForm();
    onClose();
  };

  const resetForm = () => {
    setFloorNumber('');
    setNodeElevation('');
    setProjectRopeDiameter('');
    setTableData([]);
  };

  const handleAddRow = () => {
    setIsMarksModalVisible(true);
  };

  const handleEditRow = () => {
    console.log("Редактировать строку в таблице");
  };

  const handleDeleteRow = () => {
    console.log("Удалить строку из таблицы");
  };

  const handleSaveMarks = (marksData) => {
    // Здесь будет логика сохранения данных из второй модалки
    console.log('Сохранение данных из второй модалки:', marksData);
    // Добавляем данные в таблицу как пример
    const newRow = {
      id: Date.now(),
      brand: marksData.rope || 'Новая марка',
      tension: marksData.tensions[0] || ''
    };
    setTableData(prev => [...prev, newRow]);
  };

  return (
    <>
      <CModal visible={visible} onClose={onClose} size="lg">
        <CModalHeader>
          <CModalTitle>Добавить измерение</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CForm>
            <CRow className="mb-3 align-items-end">
              <CCol md="6">
                <CFormLabel htmlFor="floorNumber">№ яруса</CFormLabel>
                <CFormInput
                  type="text"
                  id="floorNumber"
                  value={floorNumber}
                  onChange={(e) => setFloorNumber(e.target.value)}
                />
              </CCol>
              <CCol md="6">
                <CFormLabel htmlFor="nodeElevation">Отметка лацменного узла, м</CFormLabel>
                <CFormInput
                  type="text"
                  id="nodeElevation"
                  value={nodeElevation}
                  onChange={(e) => setNodeElevation(e.target.value)}
                />
              </CCol>
            </CRow>

            <hr className="my-4" />

            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <CButton color="secondary" size="sm" className="me-2" onClick={handleAddRow}>
                    Добавить
                  </CButton>
                  <CButton color="secondary" size="sm" className="me-2" onClick={handleEditRow}>
                    Редактировать
                  </CButton>
                  <CButton color="secondary" size="sm" onClick={handleDeleteRow}>
                    Удалить
                  </CButton>
                </div>
                <div className="d-flex align-items-center">
                  <CFormLabel htmlFor="projectRopeDiameter" className="mb-0 me-2">
                    Диаметр каната оттяжки по проекту, мм:
                  </CFormLabel>
                  <CFormInput
                    type="text"
                    id="projectRopeDiameter"
                    style={{ width: '100px' }}
                    value={projectRopeDiameter}
                    onChange={(e) => setProjectRopeDiameter(e.target.value)}
                  />
                </div>
              </div>

              <CTable bordered responsive>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell>Марка оттяжки</CTableHeaderCell>
                    <CTableHeaderCell>Фактическое натяжение в ярусе, тс</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {tableData.length > 0 ? (
                    tableData.map((row) => (
                      <CTableRow key={row.id}>
                        <CTableDataCell>{row.brand}</CTableDataCell>
                        <CTableDataCell>{row.tension}</CTableDataCell>
                      </CTableRow>
                    ))
                  ) : (
                    <CTableRow>
                      <CTableDataCell colSpan="2" className="text-center">
                        Нет данных
                      </CTableDataCell>
                    </CTableRow>
                  )}
                </CTableBody>
              </CTable>
            </div>
          </CForm>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={onClose}>
            Отмена
          </CButton>
          <CButton color="primary" onClick={handleSave}>
            Сохранить
          </CButton>
        </CModalFooter>
      </CModal>

      <AddTensionsMeasurementsMarks
        visible={isMarksModalVisible}
        onClose={() => setIsMarksModalVisible(false)}
        onSave={handleSaveMarks}
      />
    </>
  );
};

export default AddTensionsMeasurements;